//* 路由类型
import type { NavigateToRoute } from "@/utils/router/src/types";

export const ComponentPropsOption = {
    dark: { type: Boolean },
};

export type ComponentProps = ExtractPropTypes<typeof ComponentPropsOption>;
export type NavigationOption = {
    name: string;
    route?: string | NavigateToRoute;
    routes?: { name: string; route: string | NavigateToRoute }[];
};
